import { colors } from 'design-system';
import IconProps from './IconProps';
import VectorIcon from './VectorIcon';

const CameraIcon = ({
  width = 25,
  height = 22,
  color = colors.madison,
}: IconProps): JSX.Element => (
  <VectorIcon width={width} height={height}>
    <path
      d="M7.55688 12.5C7.55688 9.59844 9.90532 7.25 12.8069 
        7.25C15.7084 7.25 18.0569 9.59844 18.0569 12.5C18.0569 15.4016 15.7084 
        17.75 12.8069 17.75C9.90532 17.75 7.55688 15.4016 7.55688 12.5ZM12.8069 
        8.75C10.735 8.75 9.05688 10.4281 9.05688 12.5C9.05688 14.5719 10.735 16.25 
        12.8069 16.25C14.8788 16.25 16.5569 14.5719 16.5569 12.5C16.5569 10.4281 
        14.8788 8.75 12.8069 8.75ZM17.8178 2.03844L18.3053 3.5H21.8069C23.4616 3.5 
        24.8069 4.84531 24.8069 6.5V18.5C24.8069 20.1547 23.4616 21.5 21.8069 
        21.5H3.80688C2.14985 21.5 0.806885 20.1547 0.806885 18.5V6.5C0.806885 
        4.84531 2.14985 3.5 3.80688 3.5H7.30845L7.79595 2.03844C8.10064 1.11969 
        8.95845 0.5 9.92876 0.5H15.685C16.6553 0.5 17.5131 1.11969 17.8178 2.03844ZM3.80688 
        5C2.9786 5 2.30688 5.67031 2.30688 6.5V18.5C2.30688 19.3297 2.9786 20 3.80688 
        20H21.8069C22.6366 20 23.3069 19.3297 23.3069 18.5V6.5C23.3069 5.67031 22.6366 
        5 21.8069 5H17.2272L16.3975 2.51281C16.2944 2.20672 16.0084 2 15.685 2H9.92876C9.60532 
        2 9.31938 2.20672 9.21626 2.51281L8.38657 5H3.80688Z"
      fill={color}
    />
  </VectorIcon>
);

export default CameraIcon;
